export default function CarnetsConfiguration($translatePartialLoaderProvider) {
    $translatePartialLoaderProvider.addPart('carnets');
}

CarnetsConfiguration.$inject = ['$translatePartialLoaderProvider'];
